var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"25","viewBox":"0 0 18 25","fill":"none"}},[_c('path',{attrs:{"d":"M17 15.7039C13.9084 15.4902 9.05013 17.0502 9.05013 25L9.05013 1.36211e-06M0.999998 15.7039C4.09161 15.4902 8.94986 17.0502 8.94986 25","stroke":_vm.color,"stroke-width":"1.08868"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }